
export const kvaOptions = [100, 63, 25, 16, 10];

export const DEFAULT_DIVISIONS = [];
